type TranslateFn = (key: string, params?: Record<string, string | number>) => string;

export function formatRelativeDate(isoString: string, t: TranslateFn): string {
  const date = new Date(isoString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return t('date.just_now');
  if (diffMins < 60) return t('date.minutes_ago', { count: diffMins });
  if (diffHours < 24) return t('date.hours_ago', { count: diffHours });
  if (diffDays < 7) return t('date.days_ago', { count: diffDays });

  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}
